import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './analytics.service';

@Injectable({ providedIn: 'root' })
export class RouteTrackerService {
	private router = inject(Router);
	private analytics = inject(AnalyticsService);

	constructor() {
		if (typeof window === 'undefined') return;

		this.router.events.pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd)).subscribe(navEnd => {
			this.analytics.trackEvent('page_view', {
				page_path: navEnd.urlAfterRedirects,
				page_location: window.location.href
			});
		});
	}
}
